import { HelmetProvider } from "react-helmet-async";
import { Suspense, useEffect } from "react";
import { useRoutes } from "react-router-dom";
import "./App.css";
import "./styles/main.css";
import { routes } from "./routes";
import { FrappeProvider } from "frappe-react-sdk";
import { useSelector } from "react-redux";
import {
  selectCsrfTokenData,
  selectDomainData,
  selectLanguage,
  selectTokenData,
} from "./redux/AuthSlice/index.slice";
import "bootstrap/dist/css/bootstrap.min.css";
import i18n from "./utils/i18n";
function RouteLayout({ path }) {
  const element = useRoutes(path);
  return element;
}
function App() {
  const domain = useSelector(selectDomainData);
  const token = useSelector(selectTokenData);
  const csrfToken = useSelector(selectCsrfTokenData);
  const language = useSelector(selectLanguage); // adjust if your slice is nested

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);
  return (
    <HelmetProvider>
      <Suspense
        fallback={
          <div className="overlay">
            <div className="spinner"></div>
          </div>
        }
      >
        <FrappeProvider
          url={domain}
          tokenParams={{
            useToken: true,
            // Pass a custom function that returns the token as a string - this could be fetched from LocalStorage or auth providers like Firebase, Auth0 etc.
            token: () => token,
            // This can be "Bearer" or "token"
            type: "token",
          }}
          customHeaders={{
            "X-Frappe-CSRF-Token": csrfToken,
            "Accept-Language": language,
          }}
          enableSocket={false}
          swrConfig={{
            revalidateOnFocus: false,
            revalidateOnMount: true,
            revalidateIfStale: true,
          }}
        >
          <RouteLayout path={routes()} />
        </FrappeProvider>
      </Suspense>
    </HelmetProvider>
  );
}

export default App;
